import React, { Fragment, useContext, useEffect, useState } from "react";

import { PageHeader } from "../Components/Common";

import { EventsListType, PostListType, TagType } from "../Structures";
import { Empty, Tag } from "../Components/Base";
import { LoadingContext, MainContext } from "../Context";
import {
  TransactionGetBlog,
  TransactionGetEvents,
  TransactionGetTag,
} from "../Services/Transactions";
import { formatDate, formatText } from "../Utils";
import { Link } from "react-router-dom";

const Events = () => {
  const { setting } = useContext(MainContext);
  const { loading, setLoading } = useContext(LoadingContext);

  // =======================================================================

  const [tags, setTags] = useState<TagType[]>([]);
  const [posts, setPosts] = useState<PostListType[]>([]);
  const [events, setEvents] = useState<EventsListType[]>([]);

  // =======================================================================

  useEffect(() => {
    setLoading(true);
    TransactionGetEvents()
      .then(({ data: res }) => {
        if (res.transaction_status) {
          setEvents(res.data || []);
        }
      })
      .finally(() => setLoading(false));
    TransactionGetBlog()
      .then(({ data: res }) => {
        if (res.transaction_status) {
          setPosts((res.data || []).slice(0, 4));
        }
      })
      .finally(() => setLoading(false));
    TransactionGetTag()
      .then(({ data: res }) => {
        if (res.transaction_status) {
          setTags(res.data || []);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  // =======================================================================

  return (
    <Fragment>
      <PageHeader src={setting.event_banner} title="رویداد ها" />
      <section className="position-relative pt-0">
        <div className="container" data-sticky-container>
          <div className="row">
            <div className="col-lg-9">
              <Empty
                data={events}
                isLoading={loading}
                description="درحال حاضر رویدادی وجود ندارد"
              >
                <div className="row gy-4">
                  {events.map((event: EventsListType) => (
                    <div key={event.id} className="col-sm-6">
                      <Link
                        to={`/events/${event.id}`}
                        className="card cursor-pointer"
                      >
                        <div
                          className="position-relative"
                          style={{ height: 200 }}
                        >
                          <img
                            className="card-img w-100 h-100 object-fit-cover"
                            src={event.thumbnail}
                            alt={event.title}
                          />
                          <div className="card-img-overlay d-flex align-items-start flex-column p-3">
                            <div className="w-100 mt-auto">
                              {event.categories.map((tag: TagType) => (
                                <Tag key={tag.id} tag={tag} />
                              ))}
                            </div>
                          </div>
                        </div>
                        <div className="card-body px-0 pt-3">
                          <h4 className="card-title">
                            <span className="btn-link text-reset fw-bold">
                              {event.title}
                            </span>
                          </h4>
                          <p className="card-text">
                            {formatText(event.description, 100)}
                          </p>

                          <ul className="nav nav-divider align-items-center d-none d-sm-inline-block">
                            <li className="nav-item">
                              تاریخ:‌ {formatDate(event.date)}
                            </li>
                            <span className="fw-bolder mx-2">-</span>
                            <li className="nav-item">ساعت: {event.time}</li>
                          </ul>
                        </div>
                      </Link>
                    </div>
                  ))}
                </div>
              </Empty>
            </div>

            <div className="col-lg-3 mt-5 mt-lg-0">
              <div data-sticky data-margin-top="80" data-sticky-for="767">
                {tags.length ? (
                  <div>
                    <h4 className="mb-3">دسته بندی</h4>

                    {tags.map((tag) => (
                      <div
                        key={tag.id}
                        className="text-center mb-3 card-bg-scale position-relative overflow-hidden rounded"
                        style={{
                          backgroundImage: `url(${tag.image!})`,
                          backgroundPosition: "center",
                          backgroundSize: "cover",
                        }}
                      >
                        <div className="bg-dark-overlay-4 text-white p-3">
                          {tag.title}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : null}

                <div className="row">
                  <div className="col-12 col-sm-6 col-lg-12">
                    <h4 className="mb-3">آخرین اخبار</h4>
                    {posts.map((post) => (
                      <div key={post.id} className="card mb-3">
                        <div className="row g-3">
                          <div className="col-4">
                            <img
                              style={{ height: 80 }}
                              className="rounded w-100 object-fit-cover border border-1"
                              src={post.poster}
                              alt={post.title}
                            />
                          </div>
                          <div className="col-8">
                            <h6>
                              <Link
                                to={`/blog/${post.id}`}
                                className="btn-link stretched-link text-reset"
                              >
                                {post.title}
                              </Link>
                            </h6>
                            <div className="small mt-1">
                              {formatDate(post.timeStamp)}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default Events;
